import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { RequestService } from '../../request.service';

@Component({
  selector: 'app-manual-request-redirect',
  template: '',
})
export class ManualRequestRedirectComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private requestService: RequestService,
    private shareDataService: SharingDataService,
  ) { }

  ngOnInit(): void {
    var hash = this.route.snapshot.params.hash;

    this.shareDataService.currentUser.subscribe(user => {
      if(user){
        this.getDataId(hash);
      }
    })
  }

  getDataId(hash: string){
    var urls = [`portal/gethashdata?hash=${hash}`];
    
    this.requestService.getNonOData(urls, (data) => {

      var fid = data[0].data;
      this.router.navigate(['/gipReqManForm'], { queryParams: { g3e_fid: fid}});

    });
    
  }


}
